import { createFileRoute, redirect } from '@tanstack/react-router'
import React, { useState } from 'react'
import { CampaignCreateSteps } from '../campaign/components/create/campaign-create-steps'
import { CampaignCreateStepsContextProvider } from '../campaign/components/create/campaign-create-steps-context'
import { STORE_CAMPAIGN } from '../user/permission'

export const Route = createFileRoute('/_auth/_simple/campaigns/create')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(STORE_CAMPAIGN)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    component: CampaignsCreate,
})

function CampaignsCreate() {
    const [current, setCurrent] = useState(0)

    return (
        <CampaignCreateStepsContextProvider
            current={current}
            openStep={setCurrent}
        >
            <CampaignCreateSteps />
        </CampaignCreateStepsContextProvider>
    )
}
